export const employmentTags = {
  advisor: 'advisor',
  agency: 'agency',
  analytics: 'analytics',
  animation: 'animation',
  bizOps: 'business operations',
  college: 'college',
  delivery: 'delivery',
  design: 'design',
  devBackend: 'development: backend',
  devFrontend: 'development: frontend',
  devFullstack: 'development: full stack',
  devOps: 'development: ops',
  enterprise: 'enterprise',
  highCollaboration: 'high collaboration',
  food: 'food',
  gaming: 'gaming',
  installations: 'installations',
  insurance: 'insurance',
  mentoring: 'mentoring',
  partner: 'partner',
  photography: 'photography',
  product: 'product',
  rd: 'research & development',
  selfDiscipline: 'self-discipline',
  selfTaught: 'self taught',
  singleClient: 'single client centric',
  social: 'social',
  sports: 'sports',
  startup: 'startup',
  tenacity: 'tenacity',
  youth: 'youth',
  ux: 'ui/ux',
};

export default employmentTags;
